import React from 'react';
import ReportDetails from '../ReportDetails';

import {
  PRO_MFA_DESCRIPTION,
  PRO_MFA_DESCRIPTION_FOR_APPLIANCE
} from '../../utils/resources/reports';

const ReportDetailsProMFA = props => <ReportDetails {...props} />;

ReportDetailsProMFA.defaultProps = {
  title: 'Pro MFA',
  subtitle: 'last month',
  quantityName: 'Users',
  description: PRO_MFA_DESCRIPTION,
  descriptionForAppliance: PRO_MFA_DESCRIPTION_FOR_APPLIANCE,
  tabs: [
    {
      title: 'Pro MFA Users',
      selector: 'mfaUserByMonth',
      csvFilename: 'proMFAUsersByMonth',
      csvDescription:
        'This table shows monthly Pro MFA users for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        mfa_consumer: 'OTP',
        mfa_enterprise: 'Duo Security'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'OTP'
        },
        {
          title: 'Duo Security'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'mfa_consumer'
        },
        {
          keyName: 'mfa_enterprise'
        }
      ]
    },
    {
      title: 'Pro MFA Users by Tenant',
      selector: 'mfaUserByTenantMonth',
      csvFilename: 'proMFAUsersByTenantMonth',
      csvDescription:
        'This table shows monthly Pro MFA users for each tenant for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        tenant: 'Tenant',
        mfa_consumer: 'OTP',
        mfa_enterprise: 'Duo Security'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Tenant',
          keyName: 'tenant',
          isFilter: true
        },
        {
          title: 'OTP'
        },
        {
          title: 'Duo Security'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'tenant',
          isTooltip: true
        },
        {
          keyName: 'mfa_consumer'
        },
        {
          keyName: 'mfa_enterprise'
        }
      ]
    }
  ],
  applianceTabs: [
    {
      title: 'Pro MFA Users',
      selector: 'mfaUserByMonth',
      csvFilename: 'proMFAUsersByMonth',
      csvDescription:
        'This table shows monthly Pro MFA users for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        mfa_consumer: 'OTP',
        mfa_enterprise: 'Duo Security'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'OTP'
        },
        {
          title: 'Duo Security'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'mfa_consumer'
        },
        {
          keyName: 'mfa_enterprise'
        }
      ]
    },
    {
      title: 'Pro MFA Users by Private Instance',
      selector: 'mfaUserByApplianceMonth',
      csvFilename: 'proMFAUsersByApplianceMonth',
      csvDescription:
        'This table shows monthly Pro MFA users for each private instance for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        environment: 'Environment',
        root_domain_auth: 'Private Instance',
        mfa_consumer: 'OTP',
        mfa_enterprise: 'Duo Security'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Environment',
          keyName: 'environment',
          isFilter: true
        },
        {
          title: 'Private Instance',
          keyName: 'root_domain_auth',
          isFilter: true
        },
        {
          title: 'OTP'
        },
        {
          title: 'Duo Security'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'environment',
          isTooltip: true
        },
        {
          keyName: 'root_domain_auth',
          isTooltip: true
        },
        {
          keyName: 'mfa_consumer'
        },
        {
          keyName: 'mfa_enterprise'
        }
      ]
    },
    {
      title: 'Pro MFA Users by Private Instance by Tenant',
      selector: 'mfaUsersByAppplianceByTenantMonth',
      csvFilename: 'proMFAUsersByAppplianceByTenantMonth',
      csvDescription:
        'This table shows monthly Pro MFA users for each tenant for the past 12 months of the subscription.',
      csvColumns: {
        month: 'Month',
        environment: 'Environment',
        root_domain_auth: 'Private Instance',
        tenant: 'Tenant',
        mfa_consumer: 'OTP',
        mfa_enterprise: 'Duo Security'
      },
      headers: [
        {
          title: 'Month'
        },
        {
          title: 'Environment',
          keyName: 'environment',
          isFilter: true
        },
        {
          title: 'Private Instance',
          keyName: 'root_domain_auth',
          isFilter: true
        },
        {
          title: 'Tenant',
          keyName: 'tenant',
          isFilter: true
        },
        {
          title: 'OTP'
        },
        {
          title: 'Duo Security'
        }
      ],
      columns: [
        {
          keyName: 'month'
        },
        {
          keyName: 'environment',
          isTooltip: true
        },
        {
          keyName: 'root_domain_auth',
          isTooltip: true
        },
        {
          keyName: 'tenant',
          isTooltip: true
        },
        {
          keyName: 'mfa_consumer'
        },
        {
          keyName: 'mfa_enterprise'
        }
      ]
    }
  ]
};

export default ReportDetailsProMFA;
